import React from "react";
import { Box, Container, Typography, Grid } from "@mui/material";
import { motion } from "framer-motion";

import logo1 from "../../static/media/home/casos_exito/logo1.webp";
import logo2 from "../../static/media/home/casos_exito/logo2.webp";
import logo3 from "../../static/media/home/casos_exito/logo3.webp";
import logo4 from "../../static/media/home/casos_exito/logo4.webp";

const fadeInVariants = {
  hidden: { opacity: 0, scale: 0.9 },
  visible: (i) => ({
    opacity: 1,
    scale: 1,
    transition: {
      delay: i * 0.15,
      duration: 0.6,
      ease: "easeOut",
    },
  }),
};

const Partners = () => {
  const partners = [
    { logo: logo1, alt: "AshTech", url: "https://ashtech.com.ec" },
    { logo: logo2, alt: "CMSOLTEC", url: null },
    { logo: logo3, alt: "Prindela", url: "https://prindela.com" },
    { logo: logo4, alt: "DevZone", url: "https://devzone.ec" },
  ];

  return (
    <Box
      sx={{
        position: "relative",
        overflow: "hidden",
        bgcolor: "#fff",
        pb: 8,
      }}
    >
      <Container maxWidth="lg" sx={{ position: "relative", zIndex: 1 }}>
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <Typography
            variant="h3"
            fontWeight={700}
            textAlign="center"
            sx={{
              mt: 8,
              mb: 2,
              fontSize: { xs: "1.8rem", sm: "2.3rem" },
              color: "#ff6700",
            }}
          >
            Nuestros Casos de Éxito
          </Typography>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          viewport={{ once: true }}
        >
          <Typography
            variant="body1"
            color="text.secondary"
            paragraph
            textAlign="center"
            sx={{ fontSize: { xs: "1rem", sm: "1.2rem" }, mb: 6 }}
          >
            Hemos colaborado con empresas tecnológicas, distribuidores, centros de servicio técnico
            y tiendas especializadas en todo el país, entregando repuestos confiables, soporte personalizado
            y soluciones para mantener su operación en marcha.
          </Typography>
        </motion.div>

        <Grid container spacing={4} justifyContent="center" alignItems="center">
          {partners.map((item, index) => (
            <Grid item xs={6} sm={4} md={3} key={index}>
              <motion.div
                custom={index}
                initial="hidden"
                whileInView="visible"
                variants={fadeInVariants}
                viewport={{ once: true }}
              >
                {item.url ? (
                  <a href={item.url} target="_blank" rel="noopener noreferrer">
                    <Box
                      component="img"
                      src={item.logo}
                      alt={item.alt}
                      sx={{
                        display: "block",
                        mx: "auto",
                        maxWidth: { xs: 92, sm: 132, md: 162 },
                        width: "auto",
                        height: "auto",
                        objectFit: "contain",
                        cursor: "pointer",
                      }}
                    />
                  </a>
                ) : (
                  <Box
                    component="img"
                    src={item.logo}
                    alt={item.alt}
                    sx={{
                      display: "block",
                      mx: "auto",
                      maxWidth: { xs: 92, sm: 132, md: 162 },
                      width: "auto",
                      height: "auto",
                      objectFit: "contain",
                      opacity: 0.9,
                    }}
                  />
                )}
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default Partners;
